var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"justify-space-between":"","column":_vm.isMobile}},[_c('colors'),_c('preview')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }